import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import moment from 'moment';

import {
  pushData,
} from '../../reducers/account';

import './Settings.css';

class Settings extends Component {

  state = {
    pushMessage: null,
    pushing: false,
    exportedDate: null
  }

  componentDidMount = () => {
    this.getExportedDate();
  }

  getExportedDate = () => {
    window.fetch(`${window.public}/${this.props.subscription}/DateExported${window.environment === 'staging' ? `_staging` : ``}.json`).then(resp => {
      return resp.json();
    }).then(respJson => {
      this.setState({exportedDate: respJson})
    }).catch(e => {
      this.setState({exportedDate: null})
    })
  }

  componentWillReceiveProps = () => {
  }

  pushData = () => {
    this.setState({pushing: true});
    this.props.pushData((resp) => {
      if(resp.data.status) {
        this.setState({pushing: false});
        this.setState({pushMessage: 'Successfully pushed data.'});
        this.getExportedDate();
      }
    })
  }


  render() {

    const environment = window.environment;

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Settings</PageTitle>

          <div className="container-fluid" style={{margin: '50px 0'}}>
            <div className="row">
              <div className="col-md-12">
                <h3>Push Data</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <button type="button" className="btn btn-primary btn-lg" onClick={() => this.pushData() } disabled={this.state.pushing}>
                  {this.state.pushing ? `Pushing Data` : `Push Data Now`}
                </button>
                {this.state.pushMessage &&
                  <p>
                    <em>{this.state.pushMessage}</em>
                  </p>
                }
                <p>
                  <em>{this.state.exportedDate ? `Last pushed: ${moment(this.state.exportedDate.date_exported).fromNow()}` : `Cannot get last exported date`}</em>
                </p>
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Endpoints</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <form>
                  <div className="form-group row">
                    <label htmlFor="cmstoken" className="col-sm-3 col-form-label">Token</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmstoken" value={`${window.endpoint}`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsserver" className="col-sm-3 col-form-label">Point of Interests</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsserver" value={`${window.public}/${this.props.subscription}/Stores${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsamenities" className="col-sm-3 col-form-label">Amenities</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsamenities" value={`${window.public}/${this.props.subscription}/Amenities${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmscategories" className="col-sm-3 col-form-label">Categories</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmscategories" value={`${window.public}/${this.props.subscription}/Categories${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmskiosks" className="col-sm-3 col-form-label">Kiosks</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmskiosks" value={`${window.public}/${this.props.subscription}/Kiosks${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsfloorplans" className="col-sm-3 col-form-label">Floorplans</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsfloorplans" value={`${window.public}/${this.props.subscription}/Floorplans${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsassignments" className="col-sm-3 col-form-label">Assignments</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsassignments" value={`${window.public}/${this.props.subscription}/AmenitiesAssignmentCheckpoints${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmspaths" className="col-sm-3 col-form-label">Paths</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmspaths" value={`${window.public}/${this.props.subscription}/CheckpointLinksAll${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsmedias" className="col-sm-3 col-form-label">Medias</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsmedias" value={`${window.public}/${this.props.subscription}/Medias${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsevents" className="col-sm-3 col-form-label">Events</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsevents" value={`${window.public}/${this.props.subscription}/Events${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="cmsexport" className="col-sm-3 col-form-label">Pushed Timestamp</label>
                    <div className="col-sm-9">
                      <input type="text" readOnly className="form-control-plaintext font-monospace" id="cmsexport" value={`${window.public}/${this.props.subscription}/DateExported${environment === 'staging' ? `_staging` : ``}.json`} />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  subscription: state.account.subscription
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pushData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Settings);


// WEBPACK FOOTER //
// ./src/modules/Settings/Settings.js